/**
 * @readonly
 * @enum {string}
 */
export const TpmsIssueSeverityNames = Object.freeze({
    NONE: 'NORMAL',
    WARNING: 'WARNING',
    CRITICAL: 'CRITICAL',
    CATASTROPHIC: 'CATASTROPHIC'
})
